<template>
  <div class="container">
    <el-page-header @back="goBack" :content="isAdd ? '添加' : '修改'"></el-page-header>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>任务信息</span>
      </div>
      <el-form ref="form" :model="dataForm" :rules="formRules" label-width="200px">
        <el-form-item label="任务名称：" prop="taskName">
          <el-input class="input" v-model="dataForm.taskName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="taskType">
          <el-select v-model="dataForm.taskType" placeholder="请选择任务类型：">
            <el-option v-for="item in taskTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布任务机构：" prop="organization">
          <el-input class="input" disabled v-model="dataForm.organization" placeholder="请输入发布任务机构"></el-input>
        </el-form-item>
        <el-form-item label="发布任务人：" prop="creator">
          <el-input class="input" disabled v-model="dataForm.creator" placeholder="请输入发布任务人"></el-input>
        </el-form-item>
        <el-form-item label="关联残协：" prop="phone">
          <el-row>
            <el-select v-model="dataForm.useSelect" placeholder="请选择添加方式">
              <el-option key="单选" label="单选" :value="0*1">
              </el-option>
              <el-option key="批量" label="批量" :value="1*1">
              </el-option>
            </el-select>
          </el-row>
          <div v-if="dataForm.useSelect == '1'" style="margin-top: 20px;">
            <!-- <p>批量选择</p> -->
            <el-row>
              <el-col :span="6">
                <el-cascader @change="getZhenList" style="width:90%" v-model="dataForm.zhenList" :options="AreaTree"
                  :props="{ multiple: true, checkStrictly: false, label: 'name', value: 'name' }" clearable></el-cascader>
              </el-col>
              <el-col :span="4">
                <el-select @change="changeSex" v-model="dataForm.sex" placeholder="请选择性别">
                  <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="dataForm.ageSection" placeholder="请选择年龄段">
                  <el-option v-for="item in AgeGroup" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div v-if="dataForm.useSelect == '0'" style="margin-top: 20px;">
            <!-- <p>单独选择</p> -->
            <el-row>
              <el-col :span="3">
                <el-button size="mini" type="primary" @click="addOrUpdateHandle()">点击关联残协至个人
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="任务期限：" prop="selectDate">
          <el-date-picker v-model="selectDate" value-format="yyyy-MM-dd" :picker-options="pickerOptions" type="daterange"
            placeholder="请选择时间" @change="changeDate" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务详情：" prop="content">
          <wangEditor v-model="dataForm.content" :isClear="isClear" @change="wangEditorChange"></wangEditor>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 120px" type="primary" @click="onSubmit('form')"
            v-loading.fullscreen.lock="fullscreenLoading">{{ isAdd ? "添加" : "修改" }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <add-or-update :vilageVisible="addOrUpdateVisible" :taskType="dataForm.taskType"
      :echoList="dataForm.id ? dataForm.relateList : null" @transfer="getRelateList" ref="addOrUpdate"
      @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./village-add-or-update";
import mixinViewModule from "@/mixins/view-module";
import wangEditor from "@/components/wangEditor";

export default {
  mixins: [mixinViewModule],
  components: {
    AddOrUpdate,
    wangEditor,
  },
  data() {
    return {
      fullscreenLoading: false,
      mixinViewModuleOptions: {
        createdIsNeed: false,
      },
      isAdd: true,
      AreaTree: [],
      AgeGroup: [],
      sexOptions: [
        {
          value: '男',
          label: '男'
        },
        {
          value: '女',
          label: '女'
        },
      ],
      dataForm: {
        id: null,
        all: "0",
        taskName: "",
        taskType: "1",
        creator: "",
        createDate: "",
        updater: null,
        updateDate: "",
        organization: "",
        startDate: "",
        endDate: "",
        content: "",
        taskStatus: 1,
        progress: null,
        ageSection: '',
        useSelect: '',
        ageSection:'',
        sex:'',
      },
      formRules: {
        taskName: [{ required: true, trigger: "blur", message: "请输入姓名" }],
        taskType: [
          { required: true, trigger: "blur", message: "请选择任务类型" },
        ],
        organization: [
          { required: true, trigger: "blur", message: "请输入发布机构" },
        ],
        creator: [
          { required: true, trigger: "blur", message: "请输入发布任务人" },
        ],
        // selectDate: [
        //     { required: true, trigger: "blur", message: "请选择任务期限" },
        // ],
      },
      taskTypeList: [
        {
          value: "1",
          label: "就业调查",
        },
        {
          value: "2",
          label: "走访入户",
        },
        {
          value: "3",
          label: "文体活动",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      selectDate: null,
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
    };
  },
  computed: {
    info() {
      let info = window.localStorage.getItem("info");
      return JSON.parse(info);
    },
    org() {
      let org = window.localStorage.getItem("org");
      return JSON.parse(org);
    },
  },
  created() {
    this.dataForm.organization = this.org.name;
    this.dataForm.creator = this.info.name;
    this.getAreaTree();
    // this.dataForm = JSON.parse(JSON.stringify(this.dataForm));

    //有id>0的一律为编辑
    // console.log(this.$route.query.id);
    if (!this.$route.query) return;

    var query = this.$route.query.id || null;
    if (query > 0) {
      this.dataForm.id = query;
      this.getDetail(query);
      this.isAdd = false;
    } else {
      this.isAdd = true;
    }
  },
  mounted() { },
  methods: {
    getDetail(query) {
      this.fullscreenLoading = true;
      axios
        .get(this.$baseURL+ "/api/task/getInfo", {
          params: {
            id: query,
          },
        })
        .then(({ data: res }) => {
          this.fullscreenLoading = false;
          if (res.code !== 0) {
            this.dataList = [];
            this.total = 0;
            return this.$message.error(res.msg);
          }
          this.dataForm = res.data;
          // this.dataForm.useSelect=res.data.useSelect+''
          this.selectDate = [this.dataForm.startDate, this.dataForm.endDate];
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    getAreaTree() {
      //获取地区数据
      axios
        .get(this.$baseURL+ "/api/area/twoTree", {
          params: {
            area: JSON.parse(localStorage.getItem('org')).area || ''
          },
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.AreaTree = res.data;
        })
        .catch(() => { });
    },
    getZhenList(value) {
      //获取选择的地区
      // console.log(value, '获取选择的地区');

    },
    getAgeGroup(type) {
      //获取年龄段
      axios
        .get(this.$baseURL+ "/api/sys/dict", {
          params: {
            type: type,
          },
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.AgeGroup = res.data;
        })
        .catch(() => { });
    },
    changeSex(e) {
      this.dataForm.ageSection = ''
      let type = null
      if (e == '男') {
        type = 'men_Age'
      } else {
        type = 'women_Age'
      }
      this.getAgeGroup(type)
    },
    goBack() {
      this.$router.back(-1);
    },
    onSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.editWorker();
        } else {
          this.$message({
            message: "请完整填写信息",
          });
        }
      });
    },
    async editWorker() {
      var parms = JSON.parse(JSON.stringify(this.dataForm));
      if (!this.isAdd) {
        parms.workerId = this.id;
      }
      await this.dataFormSubmitHandle(parms);
    },
    // 表单提交
    dataFormSubmitHandle(dataForm) {
      this.fullscreenLoading = true;
      axios
        .post(
          this.dataForm.id ? this.$baseURL+ "/api/task/update" : this.$baseURL+ "/api/task/save",
          this.dataForm,
          { headers: { "content-type": "application/json" } }
        )
        .then(({ data: res }) => {
          this.fullscreenLoading = false;
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          // this.$message({
          //   message: this.$t("prompt.success"),
          //   type: "success",
          //   duration: 500,
          //   onClose: () => {
          //     this.visible = false;
          //     this.$emit("refreshDataList");
          //   },
          // });
          if (res.msg == "success") {
            this.$message({
              message: this.isAdd ? "添加成功" : "修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.goBack();
            }, 300);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },

    changeDate() {
      //选择日期
      this.dataForm.startDate = this.selectDate[0];
      this.dataForm.endDate = this.selectDate[1];
    },
    wangEditorChange(val) {
      //富文本内容改变
    },
    addOrUpdateHandle(id) {
      //打开村列表
      this.dataForm.useSelect = 0
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.id = id;
        this.$refs.addOrUpdate.init();
      });
    },
    getRelateList(relateList) {
      //获取村/村人的数据
      this.dataForm.relateList = relateList;
      this.addOrUpdateVisible = false;
    },
  },
};
</script>

<style scoped>
.form {
  background-color: #ffffff;
}

.el-input {
  width: 350px;
}

.box-card {
  margin-top: 30px;
}

.disabled .el-upload--picture-card {
  display: none;
}

.tips {
  display: block;
  color: #8c939d;
  font-size: 12px;
}

.tip {
  font-size: 12px;
  color: #8c939d;
}
</style>
